import { API_BASE_URL, getAuthHeader } from '../config';

export const api = {
    // Auth
    register: async (userData) => {
        const response = await fetch(`${API_BASE_URL}/auth/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userData),
        });
        if (!response.ok) throw new Error(await response.text());
        return response.json();
    },

    login: async (credentials) => {
        const response = await fetch(`${API_BASE_URL}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(credentials),
        });
        if (!response.ok) throw new Error(await response.text());
        const data = await response.json();
        if (data.token) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));
        }
        return data;
    },

    googleLogin: async (googleToken) => {
        const response = await fetch(`${API_BASE_URL}/auth/google`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: googleToken }),
        });
        if (!response.ok) throw new Error(await response.text());
        const data = await response.json();
        if (data.token) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));
        }
        return data;
    },

    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    },

    // Listings
    getListings: async (type, filters = {}) => {
        const params = new URLSearchParams({ type, ...filters });
        const response = await fetch(`${API_BASE_URL}/listings?${params}`);
        if (!response.ok) throw new Error(await response.text());
        return response.json();
    },

    createListing: async (listingData) => {
        const response = await fetch(`${API_BASE_URL}/listings`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader()
            },
            body: JSON.stringify(listingData),
        });
        if (!response.ok) throw new Error(await response.text());
        return response.json();
    },

    // Admin
    getPendingListings: async () => {
        const response = await fetch(`${API_BASE_URL}/listings/pending`, {
            headers: getAuthHeader()
        });
        if (!response.ok) throw new Error(await response.text());
        return response.json();
    },

    updateListingStatus: async (id, status) => {
        const response = await fetch(`${API_BASE_URL}/listings/${id}/status`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader()
            },
            body: JSON.stringify({ status }),
        });
        if (!response.ok) throw new Error(await response.text());
        return response.json();
    }
};
